import React from "react";
import Pjdb1TextField from "../../../../../components/inputs/Pjdb1TextField";
import WithLabel from "./WithLabel";
import {workAttrList} from "../../../types/workForm";

export interface InstanceDescriptionProps {
  // eslint-disable-next-line react/require-default-props
  value?: string | number;
  // eslint-disable-next-line react/require-default-props
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line react/require-default-props
  required?: boolean;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  // eslint-disable-next-line react/require-default-props
  isClear?: boolean;
}

export default function InstanceDescription(props: InstanceDescriptionProps) {
  return (
    <WithLabel label={workAttrList.description.label}>
      <Pjdb1TextField
        multiline
        rows={4}
        label={workAttrList.description.label}
        name={workAttrList.description.key}
        value={props.value ?? ''}
        required={props.required}
        onChange={props.onChange}
        disabled={props.disabled}
        isClear={props.isClear}
        xs={6}
        toolTip={<>サンプルを特定するための参考メモ<br/>
          パッケージ特徴や購入場所など</>
        }
      />
    </WithLabel>
  )
}
